export default __webpack_public_path__ + "static/media/clock.106b0ff3.svg";